import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "../lib/auth.server"
import {
  createCarrier,
  listCarriers,
  updateCarrier,
} from "../lib/carriers.server"

export const listCarriersFn = createServerFn({ method: "GET" })
  .validator((data?: { includeInactive?: boolean }) => data)
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listCarriers(data)
  })

export const createCarrierFn = createServerFn({ method: "POST" })
  .validator((data: unknown) => z.object({ name: z.string() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createCarrier(data.name)
  })

export const updateCarrierFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateCarrier(data)
  })
